import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getAffiliateDetails } from '../../../actions/AffiliateDetails'
import TopNav from '../../includes/TopNav.js';
import { Link } from 'react-router-dom';
import {getUserSession} from '../../../actions/user.js';

class AffiliateDetails extends Component {
  constructor(props) {
    super(props);
    this.getUserSession();
  }
  getUserSession(){
    console.log('getting user session');
    this.props.dispatch(getUserSession(ret => {
      if(ret !== false && ret.user.role !== 'admin') {
        window.location.href = "/login";
      } else if(ret === false) {
        window.location.href = "/login";
      }
    }));
  }
  componentDidMount() {
    this.getAffiliateDetails(this.props.match.params.affCode);
  }
  getAffiliateDetails(couponId) {
    this.props.dispatch(getAffiliateDetails(couponId));
  }
  render() {
      var affiliated = '';
      if(this.props.AffiliateDetails.affiliated !== false) {
        affiliated = this.props.AffiliateDetails.affiliated.map((user, i) => {
          return(<li key={i}>{user.email}</li>)}
        );
      }
      return(
        <div>
           <TopNav />
            <br/><br/>
              <section className="admin-container">
                <div>
                  {(this.props.AffiliateDetails.affiliator !== false)? 
                    <div>Client {this.props.AffiliateDetails.affiliator.email} brought in the following users:</div>
                    :
                    <div></div>
                  }
                  Affiliated:<br />
                  <ol style={{'marginLeft': '40px'}}>
                    {affiliated}
                  </ol>
                </div>
                <Link to="/admindashboard/affiliates">Back</Link>
              </section>
        </div>
      )
  }
}
export default connect( ({AffiliateDetails}) => ({AffiliateDetails}) ) (AffiliateDetails)


// WEBPACK FOOTER //
// ./src/components/dashboards/AdminDashboard/AffiliateDetails.js